"use client";

import { FC } from "react";
import classNames from "classnames";

import { IconType } from "@types";

import { Icon } from "components/atoms/Icon/Icon";

import { useTranslations } from "next-intl";
import s from "./NoResults.module.scss";

interface Props {
  copy?: string;
  startNewSearchCopy?: string;
  hideIcon?: boolean;
  onClearClick?: () => void;
}

export const NoResults: FC<Props> = ({ copy, startNewSearchCopy, hideIcon, onClearClick }) => {
  const t = useTranslations("search");

  const handleClearClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (onClearClick) onClearClick();
  };

  return (
    <div
      className={classNames(s.NoResults, {
        [s.NoIcon]: hideIcon,
      })}
    >
      {!hideIcon && (
        <div className={s.NoResultsIcon}>
          <Icon name={IconType.NoResults} />
        </div>
      )}
      {copy && <div className={s.NoResultsCopy}>{copy}</div>}
      {onClearClick && (
        <p className={s.NoResultsClear}>
          <button type="button" onClick={handleClearClick}>
            {t("reset-filters")}
          </button>{" "}
          {startNewSearchCopy || t("to-start-a-new-search")}.
        </p>
      )}
    </div>
  );
};
